/**
 * Calendar arithmetic on ISO dates, in UTC so a zone cannot shift a day.
 * A day count is a COUNT, not an amount — plain integers are the right type.
 */

const DAY_MS = 86_400_000;

/** Whole days from `fromIso` to `toIso`; negative when `toIso` is earlier. */
export function daysBetween(fromIso: string, toIso: string): number {
  const from = Date.parse(`${fromIso}T00:00:00Z`);
  const to = Date.parse(`${toIso}T00:00:00Z`);
  if (!Number.isFinite(from) || !Number.isFinite(to)) return 0;
  return Math.round((to - from) / DAY_MS);
}
